import "./quotation.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
const Quotation = () => {
  useEffect(() => {
    document.title = "Quotations | Oriflamme IT Solutions";
  }, []);

  const [quotations, setQuotations] = useState([]);
  const [filteredQuotations, setFilteredQuotations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const perPage = 100;
  const navigate = useNavigate();

  // ✅ Load ALL data once
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await fetch(`${API_URL}/api/quotation`, {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (res.status === 401) {
          navigate("/login");
          return;
        }

        if (!res.ok) {
          throw new Error("Failed to fetch quotations");
        }

        const data = await res.json();

        if (data.status) {
          setQuotations(data.data);
          setFilteredQuotations(data.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  // ✅ Search filter
  useEffect(() => {
    const filtered = quotations.filter((item) => {
      const searchLower = search.toLowerCase();

      // 👉 Version logic यहाँ भी use करना पड़ेगा
      let allVersions = [item, ...(item.versions || [])];

      allVersions = allVersions
        .map((v, i) => ({ ...v, version_no: i + 1 }))
        .reverse();

      const lastVersion = allVersions[0];

      const userName = item.user?.name || lastVersion?.user?.name || "";

      return (
        item.quotation_number.toString().includes(searchLower) ||
        item.bill_company_name?.toLowerCase().includes(searchLower) ||
        item.bill_customer_name?.toLowerCase().includes(searchLower) ||
        item.bill_contact_number?.toLowerCase().includes(searchLower) ||
        userName.toLowerCase().includes(searchLower) // ✅ FIX
      );
    });

    setFilteredQuotations(filtered);
    setCurrentPage(1);
  }, [search, quotations]);

  // ✅ Pagination logic
  const lastPage = Math.ceil(filteredQuotations.length / perPage);

  const start = (currentPage - 1) * perPage;
  const paginatedQuotations = filteredQuotations.slice(start, start + perPage);

  const startItem =
    filteredQuotations.length === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const endItem = Math.min(currentPage * perPage, filteredQuotations.length);
  const totalItems = filteredQuotations.length;

  return (
    <div className="container py-3">
      {/* 🔍 SEARCH */}
      <div className="mb-3 quotation-card p-2 position-sticky top-0 z-1">
        <div className="row align-items-center">
          <div className="col-lg-4 col-md-6">
            Showing {startItem}-{endItem} of {totalItems} Total
          </div>
          <div className="col-lg-4 col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Search quotation..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="col-lg-4 col-md-6 text-end">
            <button
              className="btn btn-success"
              onClick={() => navigate("/quotation/create")}
            >
              New Quotation
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary"></div>
          <div className="mt-2">Loading...</div>
        </div>
      ) : (
        <div>
          <div className="col-8 mx-auto">
            {/* DATA */}
            {paginatedQuotations.length > 0 ? (
              paginatedQuotations.map((item) => {
                let allVersions = [item, ...(item.versions || [])];

                allVersions = allVersions
                  .map((v, i) => ({ ...v, version_no: i + 1 }))
                  .reverse();

                const lastVersion = allVersions[0];

                return (
                  <div
                    className="quotation-card  p-4 mb-4"
                    key={item.id}
                    onClick={() =>
                      (window.location.href = `/quotation/${item.id}`)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    {/* Header */}{" "}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      {" "}
                      <div className="d-lg-flex gap-3 align-items-center">
                        {" "}
                        <div className="quote-badge">
                          {" "}
                          {String(item.quotation_number).padStart(6, "0")}{" "}
                          <span className="ms-2">
                            {" "}
                            Versions:{" "}
                            {allVersions.map((v, i) => (
                              <span key={i}>
                                {" "}
                                V{v.version_no}{" "}
                                {i < allVersions.length - 1 && ","}{" "}
                              </span>
                            ))}{" "}
                          </span>{" "}
                        </div>{" "}
                        <div className="ms-3">
                          {" "}
                          Created by - <b>{lastVersion?.user?.name}</b>{" "}
                        </div>{" "}
                      </div>{" "}
                      <div className="d-flex align-items-center gap-2">
                        {/* ✅ EDIT BUTTON */}
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={(e) => {
                            e.stopPropagation(); // ❗ IMPORTANT
                            window.location.href = `/quotation/edit/${item.id}`;
                          }}
                        >
                          ✏ Edit
                        </button>
                      </div>
                    </div>{" "}
                    {/* Body */}{" "}
                    <div style={{ cursor: "pointer" }}>
                      {" "}
                      <div className="d-flex flex-wrap justify-content-between mb-2">
                        {" "}
                        <div>
                          {" "}
                          Created on:{" "}
                          {new Date(lastVersion?.quot_date)
                            .toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(",", " |")}{" "}
                        </div>{" "}
                        <div className="d-flex text-nowrap align-items-center">
                          {" "}
                          <span className="amount-badge">
                            {" "}
                            Rs. {lastVersion?.netTotal_amount}{" "}
                          </span>{" "}
                          <img
                            src="/images/next-action.png"
                            style={{ width: 25 }}
                            alt=""
                          />{" "}
                        </div>{" "}
                      </div>{" "}
                      <hr /> <div>{lastVersion?.bill_company_name}</div>{" "}
                      <div>{lastVersion?.bill_customer_name}</div>{" "}
                      <div>{lastVersion?.bill_address}</div>{" "}
                      <div>{lastVersion?.bill_contact_number}</div>{" "}
                      <div>{lastVersion?.bill_email}</div>{" "}
                      <div>{lastVersion?.bill_gst}</div>{" "}
                    </div>{" "}
                  </div>
                );
              })
            ) : (
              <div className="text-center py-5"> No Quotation Available </div>
            )}

            {/* 🔢 PAGINATION */}
            <div className="d-flex justify-content-center mt-4 flex-wrap gap-2">
              {[...Array(lastPage)].map((_, i) => (
                <button
                  key={i}
                  className={`btn ${
                    currentPage === i + 1
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quotation;
